import * as yup from 'yup';

export function shuffleArray<T>(array: Array<T>) {
  const copy = [...array];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
export function getNestedValue(obj, path) {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
}

// Helper function to set the nested object structure with yup.object().shape()
export function setNestedProperty(obj: any, path: string, value: any) {
  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (i === keys.length - 1) {
      // At the last key, set the value (fieldSchema)
      current[key] = value;
    } else {
      // If the key doesn't exist, initialize it as a nested object
      if (!current[key]) {
        current[key] = {}; // Initialize as an empty object
      }
      // Move deeper into the nested structure
      current = current[key];
    }
  }
}

// Convert the nested structure into yup.object().shape()
export function buildYupSchema(schemaObject: any): any {
  const shapeObj: { [key: string]: any } = {};
  for (const key in schemaObject) {
    if (typeof schemaObject[key] === 'object' && !yup.isSchema(schemaObject[key])) {
      // If the value is a nested object and not already a yup schema, recursively call buildYupSchema
      shapeObj[key] = yup.object().shape(buildYupSchema(schemaObject[key]));
    } else {
      // Otherwise, assign the yup schema directly
      shapeObj[key] = schemaObject[key];
    }
  }
  return shapeObj;
}

export type Unpack<T> = T extends (infer U)[] ? U : T;
